// Styles
import "vuetify/styles";
import "@fortawesome/fontawesome-pro/css/all.css";

// Composables
import { createVuetify } from "vuetify";
import { aliases, fa } from "vuetify/iconsets/fa";

// Themes
import CatpuccinTheme from "./themes/catpuccin.js";
import ClassicTheme from "./themes/classic.js";

// Customs Icons
import NebuloneIcon from "../assets/logo-NE.svg?component";

import { VBtn } from "vuetify/components/VBtn";

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
    icons: {
        defaultSet: "fa",
        aliases: {
            ...aliases,
            nebulone: NebuloneIcon,
            login: "far fa-arrow-right-to-bracket",
            logout: "fal fa-arrow-right-from-bracket",
            messages: "fal fa-envelope",
            profile: "fal fa-circle-user",
            pilotes: "fal fa-user-pilot",
            mission: "fal fa-file-signature",
            tags: "far fa-tags",
            company: "fal fa-building",
            search: "fas fa-magnifying-glass",
            close: "far fa-xmark",
            admin: "fal fa-user-group-crown",
            history: "fal fa-clock-five",
            send: "fal fa-paper-plane",
            passwordShow: "fal fa-eye",
            passwordHide: "fal fa-eye-slash",
            euro: "fal fa-euro-sign",

            // Vuetify
            ratingFull: "fas fa-star-sharp",
            ratingHalf: "fas fa-star-sharp-half-stroke",
            ratingEmpty: "fal fa-star-sharp",
            checkboxOff: "far fa-square",
            checkboxOn: "far fa-square-check",
            collapse: "fal fa-chevron-up",
            expand: "fal fa-chevron-down",
            info: "fal fa-circle-info",

            // reviewCategories
            reviewCom: "fas fa-people-line",
            reviewPro: "fas fa-briefcase",
            reviewQua: "fad fa-envelope-open-text",
            reviewExp: "fad fa-user-gear",
        },
        sets: {
            fa,
        },
    },
    theme: {
        defaultTheme: "classicLight",
        themes: {
            classicLight: ClassicTheme.light,
            classicDark: ClassicTheme.dark,
            catpuccinLatte: CatpuccinTheme.latte,
            catpuccinMocha: CatpuccinTheme.mocha,
        },
        variations: {
            colors: ["secondary"],
            lighten: 5,
            darken: 1,
        },
    },
    aliases: {
        NeBtn: VBtn,
    },
    defaults: {
        VDialog: {
            opacity: "0.47",
            VCard: {
                class: "rounded-lg",
            },
        },
        NeBtn: {
            elevation: 1,
            color: "primary",
            class: "font-weight-bold",
        },
        VTextField: {
            variant: "outlined",
            density: "compact",
            color: "primary-lighten-3",
        },
        VTextarea: {
            variant: "outlined",
            density: "compact",
            color: "primary-lighten-3",
        },
        VAutocomplete: {
            variant: "outlined",
            density: "compact",
            color: "primary-lighten-3",
        },
        VCheckbox: {
            ripple: false,
        },
        VCheckboxBtn: {
            ripple: false,
        },
    },
});
